var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cart-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "union-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.8C4 4.35817 4.35817 4 4.8 4H5.41115C6.3202 4 7.15123 4.51361 7.55777 5.32669L7.69443 5.6H18.0054C19.5408 5.6 20.6813 7.0218 20.3483 8.52063L19.4594 12.5206C19.2154 13.6187 18.2414 14.4 17.1165 14.4H10.0835C8.9586 14.4 7.98465 13.6187 7.74063 12.5206L6.44041 6.66968L6.12669 6.04223C5.99117 5.7712 5.71416 5.6 5.41115 5.6H4.8C4.35817 5.6 4 5.24183 4 4.8ZM8.19729 7.2L9.30253 12.1735C9.38386 12.5396 9.70852 12.8 10.0835 12.8H17.1165C17.4915 12.8 17.8161 12.5396 17.8975 12.1735L18.7864 8.17354C18.8974 7.67393 18.5172 7.2 18.0054 7.2H8.19729ZM10.4 16.8C9.95817 16.8 9.6 17.1582 9.6 17.6C9.6 18.0418 9.95817 18.4 10.4 18.4C10.8418 18.4 11.2 18.0418 11.2 17.6C11.2 17.1582 10.8418 16.8 10.4 16.8ZM8 17.6C8 16.2745 9.07452 15.2 10.4 15.2C11.7255 15.2 12.8 16.2745 12.8 17.6C12.8 18.9255 11.7255 20 10.4 20C9.07452 20 8 18.9255 8 17.6ZM16.8 16.8C16.3582 16.8 16 17.1582 16 17.6C16 18.0418 16.3582 18.4 16.8 18.4C17.2418 18.4 17.6 18.0418 17.6 17.6C17.6 17.1582 17.2418 16.8 16.8 16.8ZM14.4 17.6C14.4 16.2745 15.4745 15.2 16.8 15.2C18.1255 15.2 19.2 16.2745 19.2 17.6C19.2 18.9255 18.1255 20 16.8 20C15.4745 20 14.4 18.9255 14.4 17.6Z",
    fill: "#202020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.e60481a8e2fee2d4e554d505a43820c2.svg";
export { ForwardRef as ReactComponent };